import React from 'react'
import NavBarMultiCartButton from './NavBarMultiCartButton'

interface Props {
  className?: string
  allowCartPreview?: boolean
}

function NavBarCartButton(props: Props) {
  return <NavBarMultiCartButton {...props} />
}

export default React.memo(NavBarCartButton)
